/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type AssessmentResultTypeComponent = {
  id?: number
  resultType?: AssessmentResultTypeComponent.resultType
}
export namespace AssessmentResultTypeComponent {
  export enum resultType {
    PERSONALITY = 'personality',
    MOTIVATIONS = 'motivations',
    COGNITIVE = 'cognitive',
  }
}
